export default "__VITE_ASSET__aRf2rsAP__"